import { Injectable } from '@angular/core';
import * as LogRocket from 'logrocket';
import { appInjector } from '../../app-injector';
import { PI_VERSION } from '../../constants-types/constants';
import { PI } from '../../constants-types/PI.model';
import { LogEntryApi } from './LogEntryApi.connect';

// This will be set to true based on the webpack build

/* This is a high-level logger that has a number of dependencies.
It needs to be authenticated, and therefore cannot be used on the
login page, or by a number of services that may cause circular dependencies.
If you want a simple, lightweight logger, use ConsoleLogger.log*/

@Injectable({
    providedIn: 'root'
})
export class Logger {
    logError = this.logInternalNoReturn;
    logInfo = this.logInternalNoReturn;
    logInfoNoReturn = this.logInternalNoReturn;
    logInfoError = this.logInternalNoReturn;
    eventNamePrefix = 'PI SPA - ';

    constructor(private logApi: LogEntryApi) {}

    // Do not log for local development
    serverLoggingEnabled(): boolean {
        return PI.appSettings.loggingOn;
    }

    logToConsole(): boolean {
        return PI.appSettings.logToConsole;
    }

    private wrapData(data: any, loggedEventName: string) {
        return Object.assign(data, {
            appVersion: PI_VERSION,
            eventName: loggedEventName,
            logRocketSessionUrl: LogRocket?.sessionURL
        });
    }

    /**
     * log data using the Fetch API, this will survive past browser closing (window unload)
     */
    private logInternalNoReturn(eventName: string, data: any): void {
        if (appInjector) {
            if (this.serverLoggingEnabled()) {
                this.logApi.createLogEntryWithoutReturn(
                    this.wrapData(data, `${this.eventNamePrefix}${eventName}`)
                );
            } else if (this.logToConsole()) {
                console.log(
                    this.wrapData(data, `${this.eventNamePrefix}${eventName}`)
                );
            }
        }
    }
}
